import React from 'react';
import PropTypes from 'prop-types';

import Box from '@material-ui/core/Box';
import CircularProgress from '@material-ui/core/CircularProgress';

const LoadingSpinner = ({ size, ...rest }) => {
  return (
    <Box textAlign="center" p={4} mx="auto" {...rest}>
      <CircularProgress style={{ height: `${size}px`, width: `${size}px` }} />
    </Box>
  );
};

LoadingSpinner.propTypes = {
  size: PropTypes.number
};

LoadingSpinner.defaultProps = {
  size: 40
};

export default LoadingSpinner;
